import moment from 'moment';

moment.locale('de');
const dateFormat = 'YYYY-MM-DD';

// The minimum value that can be stored as Unix timestamp in the database.
const defaultMinDate = '1970-01-02';

const dateAsString = (value: string): string => {
  if (value) {
    return moment(value).format(dateFormat);
  }
  return '';
};

const dateNowAsString = (): string => {
  return moment().format(dateFormat);
};

const dateInstanceAsString = (date: Date): string => {
  return date.toISOString().split('T')[0];
};

const validateDateFormat = (date?: string): boolean => {
  if (!date) {
    return true;
  }
  return moment(date, dateFormat, true).isValid();
};

const formatDate = (value: string): string => {
  if (value) {
    return moment(value).format('L');
  }
  return '';
};

const formatDateWithWeekday = (value: string): string => {
  if (value) {
    return moment(value).format('dd, L');
  }
  return '';
};

const formatShortDate = (value: string): string => {
  if (value) {
    return moment(value).format('DD.MM.YY');
  }
  return '';
};

const formatDateTime = (value: string): string => {
  if (value) {
    return moment(value).format('L LT');
  }
  return '';
};

const formatDateTimeWithWeekday = (value: string): string => {
  if (value) {
    return moment(value).format('dd, L LT');
  }
  return '';
};

const formatShortDateTime = (value: string): string => {
  if (value) {
    return moment(value).format('DD.MM.YY HH:mm');
  }
  return '';
};

const getDateInDays = (days: number): Date => {
  const date = new Date();
  date.setDate(date.getDate() + days);
  return date;
}

export {
  dateAsString,
  dateNowAsString,
  dateInstanceAsString,
  defaultMinDate,
  formatDate,
  formatDateWithWeekday,
  formatDateTime,
  formatDateTimeWithWeekday,
  formatShortDate,
  formatShortDateTime,
  getDateInDays,
  validateDateFormat
}
